import { ScalingVector } from "@opstel/geo/Point";

// Fixed scale multiplier to get from the standardized input data to a coordinate system that looks good on screen
export const SCALING_FACTOR = 0.25;
// NOTE: Mirror on y-axis to match donna.
export const SCALING_VECTOR: ScalingVector = [SCALING_FACTOR, -1 * SCALING_FACTOR];
